import SectionContainer from '@components/SectionContainer'
import SessionsDataGrid from '../components/SessionsDataGrid'
import { UseDataSource } from '@hooks/useDataSource'

interface SessionsTableProps {
    enqueueSnackbar: typeof import('notistack').enqueueSnackbar
    dataSource: UseDataSource
}

export default function SessionsTable({
    enqueueSnackbar,
    dataSource,
}: SessionsTableProps) {
    return (
        <SectionContainer title="Sessions">
            <SessionsDataGrid
                enqueueSnackbar={enqueueSnackbar}
                {...dataSource}
            />
        </SectionContainer>
    )
}
